import { useContext } from 'react';
import WindowSizeContext from 'src/contexts/WindowSizeContext/WindowSizeContext';

const useWindowSize = () => {
  return useContext(WindowSizeContext);
};

export default useWindowSize;
